module.exports = __webpack_public_path__ + "img/arrow-down-z-a.d9f65213.svg";